/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const ArrowUpIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path fillRule="evenodd" d="M11.293 2.293a1 1 0 0 1 1.414 0l7.5 7.5a1 1 0 0 1-1.414 1.414L13 5.414V21a1 1 0 1 1-2 0V5.414l-5.793 5.793a1 1 0 0 1-1.414-1.414z" clipRule="evenodd" /></svg>;
};
export default ArrowUpIcon;